import { Box, CircularProgress, Link, Table, Typography } from "@mui/joy";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Util } from "../Helpers/Util";

export default function MissingAnnualInspections() {
	const [dataset, setDataset] = React.useState([] as Array<any>);
	const [loading, setLoading] = React.useState(true);
	const n = useNavigate();

	React.useEffect(() => getData(), []);

	const getData = () => {
		setLoading(true);
		fetch("Inspection/GetMissingAnnualInspections", {
			method: "Post",
			headers: {
				"Content-Type": "application/json",
			},
			cache: "no-cache",
			body: JSON.stringify({}),
		})
			.then((x) => x.json())
			.then((x) => {
				setDataset(x);
				setLoading(false);
			});
	};

	return (
		<Box sx={{ overflowY: "auto", padding: 2 }}>
			<Typography level="title-lg" sx={{ marginBottom: 2 }}>
				Missing / Expired Annual Inspections
			</Typography>
			<Typography level="body-sm" sx={{ marginBottom: 2 }}>
				Active-building elevators with no annual inspection on file, or last annual inspection over 1 year old.
			</Typography>
			<Table>
				<thead>
					<tr>
						<th>Building</th>
						<th>Serial Number</th>
						<th>Last Inspection</th>
						<th>Status</th>
					</tr>
				</thead>
				<tbody>
					{loading && (
						<tr>
							<td colSpan={4}>
								<div style={{ display: "flex", flexDirection: "column", width: "100%", alignItems: "center" }}>
									<CircularProgress />
								</div>
							</td>
						</tr>
					)}
					{!loading &&
						dataset.map((x) => (
							<tr key={x.elevators_id}>
								<td>
									<Link
										onClick={() => {
											n("/buildingportal/" + x.buildings_id);
										}}>
										{x.building_name}
									</Link>
								</td>
								<td>{x.serial_number}</td>
								<td>{x.last_inspection_date ? Util.Formatter(x.last_inspection_date, "D") : ""}</td>
								<td>{x.status}</td>
							</tr>
						))}
				</tbody>
			</Table>
		</Box>
	);
}
